import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/shared/services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenService {
  // Key to save the refresh token into the memory
  private readonly REFRESH_TOKEN_KEY = 'refreshToken';

  // Store access token in memory
  private userAccessToken: string;

  // Key to save target uuid in local storage
  private readonly TARGET_UUID_KEY = 'target-uuid';

  constructor(private storage: StorageService) {}

  /**
   * Set the access token to the memory.
   *
   * @param token - The access token
   */
  setAccessToken(token: string): void {
    this.userAccessToken = token;
  }

  /**
   * Set the refresh token to the local storage.
   *
   * @param token - The refresh token
   */
  async setRefreshToken(token: string): Promise<void> {
    await this.storage.set(this.REFRESH_TOKEN_KEY, token);
  }

  async getTargetUUID(): Promise<string> {
    return await this.storage.get(this.TARGET_UUID_KEY);
  }

  /**
   * Function to reset the access and refresh tokens.
   */
  async resetTokens(): Promise<void> {
    await this.storage.clear();
    this.setAccessToken(null);
  }

  /**
   * Getter for the access token.
   */
  get accessToken(): string {
    return this.userAccessToken;
  }

  /**
   * Getter for the refesh token.
   * Reads `REFRESH_TOKEN_KEY` from storage.
   */
  async refreshToken(): Promise<string> {
    // make sure the storage is ready
    await this.storage.ready();

    return await this.storage.get(this.REFRESH_TOKEN_KEY);
  }
}
